import React, { ElementType, ReactElement, ReactNode } from 'react'
import { Flex, Text } from 'theme-ui'
import { Svg } from 'ui'
import VerticalDivider from 'ui/VerticalDivider'

export default function CompactFeatures({ children }: { children: ReactNode }): ReactElement {
  return (
    <Flex
      sx={{
        width: '100%',
        flexDirection: ['column', 'row'],
        py: ['4rem', '6.4rem'],
        px: ['3.2rem', '4rem'],
        alignItems: 'center',
        borderBottom: '1px solid',
        borderTop: '1px solid',
        borderColor: 'blueYonder20',
        gap: ['4rem', '1.2rem', '2.4rem'],
        justifyContent: 'center',
        backgroundColor: 'blueYonder5',
        '@media screen and (min-width: 768px) and (max-width: 980px)': {
          px: '0.8rem',
          gap: '0.4rem',
        },
      }}
    >
      {children}
    </Flex>
  )
}

export function FeaturesDivider(): ReactElement {
  return (
    <VerticalDivider
      sx={{
        display: ['none', 'block'],
        width: '1px',
        height: '14.1rem',
        backgroundColor: 'blueYonder20',
        flexShrink: 0,
      }}
    />
  )
}

export function FeaturesItem({
  icon,
  title,
  description,
}: {
  icon: ElementType
  title: string
  description?: string
}): ReactElement {
  return (
    <Flex
      sx={{
        maxWidth: ['100%', '29.2rem'],
        height: '14.1rem',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Svg svg={icon} sx={{ mb: '1.6rem' }} descriptiveText={`Feature icon for ${title}`} />
      <Text
        variant="size16Weight500Line138Letter032"
        sx={{
          color: 'aliceBlue',
          mb: '0.4rem',
          '@media screen and (min-width: 768px) and (max-width: 980px)': {
            fontSize: '1.4rem',
          },
        }}
      >
        {title}
      </Text>
      {description && (
        <Text
          variant="size13Weight500Line136Letter013"
          sx={{
            color: 'wildBlueYonder',
            '@media screen and (min-width: 768px) and (max-width: 980px)': {
              fontSize: '1.2rem',
            },
          }}
        >
          {description}
        </Text>
      )}
    </Flex>
  )
}
